import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios"

import { api360 } from "./api";
import { ActivityLogPayload, GetHomeLeadsPayload, GetLeadDetailPayload, ImportLeadsPayload, LeadsImportHistorySearchPayload, LeadsSearchPayload, LeadsSummaryPayload, LeadsTemplatePayload, SearchReq, UpdateLeadDetailPayload } from "../types/leads.types";


export const getLeadSummary = (data: LeadsSummaryPayload): Promise<AxiosResponse> => {
    const mockData = {
        "totalLads": 5523,
        "newLeads": 752,
        "qualified": 625,
        "conversionRate": 0.035,
        "wonDeals": 324,
        "score": 7.7
    }


    const url = "/c360/v1/api/lead/summary";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    //     status: 200,
    //     statusText: "OK",
    //     headers: {},
    //     config: {}
    // } as AxiosResponse);
}
export const getLeadPipelines = (data: SearchReq): Promise<AxiosResponse> => {
    // Mock data since API is not ready
    const mockData = {
        leadPipelines: {
            new: 752,
            contracted: 828,
            qualified: 625,
            proposal: 442,
            negotiation: 276,
            won: 324,
            lost: 89
        }
    };

    const url = "/c360/v1/api/lead/pipeline";
    return api360.post(url, data);
    //     return Promise.resolve({
    //         data: mockData,
    //     } as AxiosResponse);
}
export const getLeadDistribution = (data: SearchReq): Promise<AxiosResponse> => {
    const mockData = { "leadTypes": { "crossSell": 20, "upsell": 26, "unclaimed": 9, "nearingMaturity": 5, "newBusiness": 35, "unclaimedMatured": 2, "maturedRecently": 3 } }

    const url = "/c360/v1/api/lead/distribution";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);

}

export const getMetricsFromAssignedChannel = (data: LeadsSummaryPayload): Promise<AxiosResponse> => {
    const mockData = {
        wonDeals: {
            "Omne by FWD": 28,
            "Digital Commerce": 15,
            "Fit for me": 9,
            "Cube": 12,
            "GCash": 18,
            "Traveloka": 24
        },
        qualification: {
            "Omne by FWD": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Digital Commerce": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Fit for me": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Cube": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "GCash": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Traveloka": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            }
        },
        ape: {
            "Omne by FWD": 2,
            "Digital Commerce": 25,
            "Fit for me": 9,
            "Cube": 10,
            "GCash": 8,
            "Traveloka": 44
        }

    }

    const url = "/c360/v1/api/lead/metrics/assignedchannel";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}


export const getMetricsFromSourceChannel = (data: LeadsSummaryPayload): Promise<AxiosResponse> => {
    const mockData = {
        wonDeals: {
            "Omne by FWD": 28,
            "Digital Commerce": 15,
            "Fit for me": 9,
            "Cube": 12,
            "GCash": 18,
            "Traveloka": 24
        },
        qualification: {
            "Omne by FWD": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Digital Commerce": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Fit for me": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Cube": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "GCash": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            },
            "Traveloka": {
                "warm": 20,
                "hot": 4,
                "cold": 8
            }
        },
        ape: {
            "Omne by FWD": 10,
            "Digital Commerce": 12,
            "Fit for me": 1,
            "Cube": 2,
            "GCash": 8,
            "Traveloka": 14
        }
    }


    const url = "/c360/v1/api/lead/metrics/sourcechannel";
    return api360.post(url, data);

    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}


export const getAccumulatedChartData = (data: LeadsSummaryPayload): Promise<AxiosResponse> => {
    const mockData = {
        "accumulationCount": {
            "2025-10-14": 0,
            "2025-10-15": 1,
            "2025-10-16": 1,
            "2025-10-17": 1,
            "2025-10-18": 1,
            "2025-10-19": 1,
            "2025-10-20": 1,
            "2025-10-21": 1,
            "2025-10-22": 2,
            "2025-10-23": 2,
            "2025-10-24": 2,
            "2025-10-25": 2,
            "2025-10-26": 2,
            "2025-10-27": 2,
            "2025-10-28": 2,
            "2025-10-29": 2,
            "2025-10-30": 3,
            "2025-10-31": 3
        }
    }

    const url = "/c360/v1/api/lead/accumulation";
    return api360.post(url, data);

    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}

export const getSourceChannelOptions = (data: SearchReq): Promise<AxiosResponse> => {
    const mockData = { options: ["Omne by FWD", "Digital Commerce", "Fit for me", "Cube", "GCash", "Traveloka"] }

    const url = "/c360/v1/api/lead/options/channels";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);

}

export const getSourceChannelList = (data: SearchReq): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/options/getSourceChannelList";
    
    return api360.post(url, data);
}

export const getLeadTemplate = (data: LeadsTemplatePayload): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/getTemplate";
    
    return api360.post(url, data);
}


export const importLeads = (data: ImportLeadsPayload): Promise<AxiosResponse> => {
  const url = "/c360/v1/api/lead/import";

  const formData = new FormData();
  formData.append("userName", data.userName);
  formData.append("channelName", data.channelName);
  formData.append("permission_Token", data.permission_Token);
  formData.append("file", data.file, data.file.name);

  return api360.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getAssignedChannelOptions = (data: SearchReq): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/options/assignedchannels";
    return api360.post(url, data);
}

export const getStatusOptions = (data: SearchReq): Promise<AxiosResponse> => {
    const mockData = { options: ["New", "Contacted", "Qualified", "Proposal", "Negotiation", "Won", "Lost"] }
    const url = "/c360/v1/api/lead/options/statuses";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);

}

export const getSearchLeads = (data: LeadsSearchPayload): Promise<AxiosResponse> => {
    const mockData = {
        "records": [
            {
                "id": "a79e1bfc-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "An TH",
                "emailAddress": "anth@yopmail.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 4,
                "channel": "Omne",
                "leadType": "qualified",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Health",
                    "Critical Illness",
                    "Life and Accident",
                    "Savings",
                    "Annuity"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e21f2-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "hương",
                "emailAddress": "huong.nguyen3+th3@monstar-lab.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 7,
                "channel": "Omne",
                "leadType": "New",
                "status": "contacted",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Health"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e2415-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "Luan Vu SIT TH1",
                "emailAddress": "luan.vu+sit+thv1@monstar-lab.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 8,
                "channel": "Omne",
                "leadType": "New",
                "status": "won",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Life and Accident"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e253f-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "hương",
                "emailAddress": "huong.nguyen3+th3@monstar-lab.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 2,
                "channel": "Omne",
                "leadType": "lost",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Annuity"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e2627-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "string",
                "emailAddress": "gremenden@gmail.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 10,
                "channel": "Omne",
                "leadType": "New",
                "status": "negotiation",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Unknown"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e2719-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "jvjvh",
                "emailAddress": "huong.nguyen3+th5@monstar-lab.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 7,
                "channel": "Omne",
                "leadType": "New",
                "status": "lost",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Annuity"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e280e-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "NewDevice3",
                "emailAddress": "onb003sit036@yopmail.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 8,
                "channel": "Omne",
                "leadType": "New",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Health",
                    "Critical Illness"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e2906-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "An TH 1",
                "emailAddress": "anth+1@yopmail.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 6,
                "channel": "Omne",
                "leadType": "New",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Health",
                    "Life and Accident"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e29f3-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "Luan Vu SIT TH2",
                "emailAddress": "luan.vu+sit+thv2@monstar-lab.com",
                "contactPhoneNumber": null,
                "jobPosition": "Insurance",
                "leadScore": 10,
                "channel": "Omne",
                "leadType": "New",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Health",
                    "Savings"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            },
            {
                "id": "a79e2acf-b3df-11f0-9cd7-0a755fbfa3bf",
                "fullName": "huong th2",
                "emailAddress": "huong.nguyen3+th2@monstar-lab.com",
                "contactPhoneNumber": "",
                "jobPosition": "Insurance",
                "leadScore": 5,
                "channel": "Omne",
                "leadType": "New",
                "status": "New",
                "assignedChannel": "Omne",
                "suggestedType": [
                    "Life and Accident",
                    "Annuity",
                    "Savings",
                    "Critical Illness"
                ],
                "lastContacted": "Omne",
                "suggestEta": "2025-10-30T00:00:00",
                "suggestEtaText": "1 day",
                "assignedTo": "John Doe",
                "lastContactDate": "2025-10-29T00:00:00",
                "availableInOmne": true
            }
        ],
        "total": 29,
        "pagination": {
            "currentPage": 1,
            "pageSize": 10,
            "totalPages": 3
        }
    }

    const url = "/c360/v1/api/lead/search";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}

export const getImportHistoryList = (data: LeadsImportHistorySearchPayload): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/getImportHistoryList";
    return api360.post(url, data);
}

export const getCustomerStatusOptions = (data: SearchReq): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/options/customerresponse";
    return api360.post(url, data);
}

export const getLeadDetails = (data: GetLeadDetailPayload): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/detail";
    return api360.post(url, data);
}

export const updateLeadDetails = (data: UpdateLeadDetailPayload): Promise<AxiosResponse> => {
    const url = "/c360/v1/api/lead/edit-detail";
    return api360.post(url, data);
}

export const getActivityLog = (data: ActivityLogPayload): Promise<AxiosResponse> => {

    const mockData = {
        pagiantion: {
            "CurrentPage": 1,
            "pageSize": 10
        },
        records: [
            {

                id: "a14b2362-da1a-4d29-aef0-eb127d3ccca4",

                user: "Test Approver",

                action: "Update",

                details: {

                    customerResponse: "705",

                    remarks: "Test17"

                },

                createdDateTime: "2025-10-31T07:22:22",

                modifiedDateTime: "2025-10-31T07:22:22"

            }
        ],
        total: 1
    }
    const url = "/c360/v1/api/lead/activity-log";
    return api360.post(url, data);

    //  return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}

export const getWeeklyOrMonthlySummary = (data: GetHomeLeadsPayload): Promise<AxiosResponse> => {
    const isWeekly = data.frequency === "weekly";

    const mockData = {
        graphSummaryResponse: {
            graphData: isWeekly ? [
                { "x": "Sat", "y": 1 },
                { "x": "Sun", "y": 4 },
                { "x": "Mon", "y": 0 },
                { "x": "Tue", "y": 3 },
                { "x": "Wed", "y": 4 },
                { "x": "Thu", "y": 0 },
                { "x": "Fri", "y": 0 }
            ] : [
                { "x": "1", "y": 12 },
                { "x": "2", "y": 19 },
                { "x": "3", "y": 8 },
                { "x": "4", "y": 15 },
                { "x": "5", "y": 22 },
                { "x": "6", "y": 18 },
                { "x": "7", "y": 25 },
                { "x": "8", "y": 14 },
                { "x": "9", "y": 20 },
                { "x": "10", "y": 16 },
                { "x": "11", "y": 28 },
                { "x": "12", "y": 24 }
            ]
        },
        leadSummaryResponse: {
            "totalLeads": isWeekly ? 12 : 241,
            "newLeads": isWeekly ? 8 : 156,
            "qualified": isWeekly ? 5 : 89,
            "conversionRate": isWeekly ? 0.42 : 0.37,
            "wonDeals": isWeekly ? 3 : 45,
            "score": isWeekly ? 7.2 : 8.1,
            "hot": isWeekly ? 2 : 34,
            "warm": isWeekly ? 4 : 67,
            "cold": isWeekly ? 6 : 95
        }
    }

    const url = "/c360/v1/api/lead/homepage";
    return api360.post(url, data);

    // return Promise.resolve({
    //         data: mockData,
    //     } as AxiosResponse);


}

export const getSocialInsightsData = (data: SearchReq): Promise<AxiosResponse> => {
    const mockData = [
    {
        "id": "70cf2b4f-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "News",
        "views": 11550810000,
        "posts": 909740,
        "dataInsights": "7% of views with steady posts, reflecting timely, informative consumption.",
        "audienceTrend": "25-34 demo shows concerned, analytical sentiment toward current events, trending toward awareness of risks like accidents.",
        "opportunity": "Use news hooks (e.g., accident reports) to pivot to proactive FWD solutions.",
        "action": "Create reaction videos under #News, linking real stories to life insurance benefits for emotional resonance.",
        "relevanceAssessmentScore": "Medium",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Relevant for risk-highlighting—tailor content via hashtags to educate on accident/life threats, positioning FWD as a timely protector for conversions.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf54f1-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Fashion/Beauty",
        "views": 11509880000,
        "posts": 2911900,
        "dataInsights": "7% of views with strong post activity, emphasizing aspirational visuals.",
        "audienceTrend": "Users display confident, self-care trends with positive sentiment around personal enhancement.",
        "opportunity": "Tie \"protecting your glow-up\" to life insurance for long-term beauty/lifestyle security.",
        "action": "Sponsor #FashionBeauty hauls with FWD \"future-proof\" segments, showing accident coverage for active lifestyles.",
        "relevanceAssessmentScore": "Low",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Indirect relevance—leverage for aspirational content, but hashtags less ideal for direct life/accident sales tailoring.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf57c3-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Food",
        "views": 10058880000,
        "posts": 610620,
        "dataInsights": "6% of views with balanced posts, indicating relatable daily engagement.",
        "audienceTrend": "Foodies show indulgent, communal sentiment, trending toward health-conscious twists.",
        "opportunity": "Link family meals to legacy planning via life insurance in wholesome content.",
        "action": "Duet #Food recipes with FWD tips on \"protecting family feasts\" from accidents.",
        "relevanceAssessmentScore": "Low",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Minimal direct tie—use for family-oriented life insurance angles, but hashtags better for soft engagement than sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf58d3-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Finance",
        "views": 7677630000,
        "posts": 4192260,
        "dataInsights": "5% of views but 12% of posts, showing deep, discussion-heavy interest.",
        "audienceTrend": "25-34 users exhibit pragmatic, goal-oriented sentiment, trending toward wealth-building and risk hedging.",
        "opportunity": "Directly integrate FWD life/accident products into financial planning narratives for trust-building.",
        "action": "Host #Finance AMAs with experts, demoing how FWD fits budgeting for life's uncertainties.",
        "relevanceAssessmentScore": "High",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Core relevance—insights perfectly align. Hashtags enable tailored content on financial security via life/accident insurance, driving educational sales",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5977-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Pets",
        "views": 5930000000,
        "posts": 468550,
        "dataInsights": "4% of views with consistent posts, reflecting emotional bonding.",
        "audienceTrend": "Pet owners show affectionate, nurturing trends with high loyalty sentiment.",
        "opportunity": "Extend to family protection analogies (pets as \"family members\") for accident coverage.",
        "action": "Create pet-inclusive #Pets videos showing \"whole family\" FWD plans.",
        "relevanceAssessmentScore": "Low",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Tangential—leverage for emotional life insurance storytelling, but no pet products limit sales tailoring.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5a11-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Lifestyle",
        "views": 5789740000,
        "posts": 903660,
        "dataInsights": "4% of views with solid posts, capturing holistic daily vibes.",
        "audienceTrend": "Users pursue balanced, aspirational lives with optimistic sentiment toward wellness and planning.",
        "opportunity": "Frame FWD as essential for sustainable lifestyles against accidents/life risks.",
        "action": "Produce day-in-life series under #Lifestyle, inserting FWD \"safety nets\" for 25-34 planners.",
        "relevanceAssessmentScore": "High",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Strong fit—tailor content via hashtags to show life/accident insurance enabling worry-free lifestyles, ideal for sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5b3a-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Education",
        "views": 5194580000,
        "posts": 548110,
        "dataInsights": "3% of views with focused posts, indicating value-driven learning.",
        "audienceTrend": "Learners show motivated, self-improving sentiment, trending toward practical skills like financial literacy.",
        "opportunity": "Educate on insurance as \"life education\" to build long-term customer loyalty.",
        "action": "Develop explainer reels with #Education creators, breaking down FWD life/accident benefits simply.",
        "relevanceAssessmentScore": "High",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Directly relevant—use hashtags for literacy-focused content, tailoring to demystify products for informed sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5bd4-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Indonesian Culture",
        "views": 4144030000,
        "posts": 320420,
        "dataInsights": "3% of views with cultural depth in posts.",
        "audienceTrend": "Prideful, communal sentiment around traditions, trending toward modern adaptations.",
        "opportunity": "Localize FWD messaging with cultural \"protection of heritage/family\" themes.",
        "action": "Tie #IndonesianCulture festivals to FWD stories of safeguarding legacies via life insurance.",
        "relevanceAssessmentScore": "Medium",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Culturally resonant—leverage for family-centric life insurance content, enhancing relevance in Indonesia for sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5d10-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Travel/Nature",
        "views": 4106060000,
        "posts": 539890,
        "dataInsights": "3% of views with adventure-oriented posts.",
        "audienceTrend": "Explorers show excited, risk-embracing sentiment, trending toward safe adventures.",
        "opportunity": "Highlight accident coverage for travel mishaps to capture aspirational users.",
        "action": "User-generated #TravelNature challenges with FWD \"wander safely\" overlays.",
        "relevanceAssessmentScore": "High",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Excellent for accident insurance—tailor via hashtags to address travel risks, driving product-specific sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5dda-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Sports",
        "views": 3689830000,
        "posts": 342590,
        "dataInsights": "2% of views with energetic posts.",
        "audienceTrend": "Athletes display determined, health-focused trends with positive injury-recovery sentiment.",
        "opportunity": "Promote accident insurance as \"gear for life's game.\"",
        "action": "Sponsor #Sports athlete testimonials on FWD covering sports injuries.",
        "relevanceAssessmentScore": "High",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Spot-on for accident products—use hashtags to tailor injury-prevention content, boosting credibility and sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5e72-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "General/Utility",
        "views": 2501460000,
        "posts": 583990,
        "dataInsights": "2% of views with practical post volume.",
        "audienceTrend": "Users seek efficient, problem-solving tips with neutral, utility-driven sentiment.",
        "opportunity": "Position FWD as a \"utility essential\" for everyday risks.",
        "action": "Quick-tip series under #GeneralUtility, e.g., \"insure your daily commute.\"",
        "relevanceAssessmentScore": "Medium",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Practical tie-in—leverage for straightforward life/accident education, suitable for broad sales awareness.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf5f53-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "Religion",
        "views": 2249220000,
        "posts": 225900,
        "dataInsights": "1% of views with reflective posts.",
        "audienceTrend": "Faithful users show spiritual, community-oriented sentiment, trending toward peace-of-mind themes.",
        "opportunity": "Align life insurance with \"providing for loved ones eternally.\"",
        "action": "Sensitive #Religion content partnering with faith leaders on legacy planning.",
        "relevanceAssessmentScore": "Medium",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Emotionally relevant for life insurance—tailor respectfully via hashtags for trust-building in sales.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    },
    {
        "id": "70cf601a-bf74-11f0-b0e6-0a15803a21c9",
        "source": "TikTok",
        "country": "Indonesia",
        "category": "National Event",
        "views": 1630000000,
        "posts": 113080,
        "dataInsights": "1% of views with event-spiked posts.",
        "audienceTrend": "Patriotic, celebratory trends with unifying sentiment.",
        "opportunity": "Tie FWD to national pride in \"protecting Indonesia's future.\"",
        "action": "Event-timed #NationalEvent activations showing family safety during celebrations.",
        "relevanceAssessmentScore": "Low",
        "s3FilePath": "",
        "relevanceAssessmentRationale": "Seasonal relevance—use for patriotic life insurance angles, but limited for ongoing sales tailoring.",
        "insightsGeneratedDatetime": "2025-11-12T03:05:27",
        "createdDateTime": "2025-11-12T03:05:27",
        "modifiedDateTime": "2025-11-12T03:05:27"
    }
]
    
    const url = "/c360/v1/api/lead/getsocialinsightsdata";
    return api360.post(url, data);
    // return Promise.resolve({
    //     data: mockData,
    // } as AxiosResponse);
}


export const useGetSourceChannelOptions = (data: SearchReq) => {
    return useQuery({
        queryKey: ["ChannelOptions"],
        queryFn: () => getSourceChannelOptions(data),
    });
}

export const useGetSourceChannelList = (data: SearchReq) => {
    return useQuery({
        queryKey: ["ChannelList"],
        queryFn: () => getSourceChannelList(data),
    });
}

export const useGetLeadTemplate = (
  payload: LeadsTemplatePayload,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["leadTemplate", payload.channelName, payload.permission_Token],
    queryFn: () => getLeadTemplate(payload),
    enabled: options?.enabled ?? false, // Prevent auto-fetch on mount
    refetchOnWindowFocus: false, // Avoid unnecessary refetch
  });
};

export const useImportLeadsApi = () => {
  return useMutation({
    mutationFn: importLeads,
  });
};

export const useGetAssignedChannelOptions = (data: SearchReq) => {
    return useQuery({
        queryKey: ["AssignedChannelOptions"],
        queryFn: () => getAssignedChannelOptions(data),
    });
}

export const useGetStatusOptions = (data: SearchReq) => {
    return useQuery({
        queryKey: ["StatusOptions", data.permission_Token],
        queryFn: () => getStatusOptions(data),
    });
}

export const useSearchLeads = () => {
    return useMutation({
        mutationFn: (data: LeadsSearchPayload) => getSearchLeads(data),
    });
}

export const useSearchLeadHistoryList = () => {
    return useMutation({
        mutationFn: (data: LeadsImportHistorySearchPayload) => getImportHistoryList(data),
    });
}

export const useGetCustomerStatusOptions = (data: SearchReq) => {
    return useQuery({
        queryKey: ["CustomerStatusOptions"],
        queryFn: () => getCustomerStatusOptions(data),
    });
}

export const useGetLeadDetails = () => {
    return useMutation({
        mutationFn: (data: GetLeadDetailPayload) => getLeadDetails(data),
    });
}

export const useUpdateLeadDetails = () => {
    return useMutation({
        mutationFn: (data: UpdateLeadDetailPayload) => updateLeadDetails(data),
    });
}

export const useGetActivityLog = () => {
    const mutation = useMutation({
        mutationFn: (data: ActivityLogPayload) => getActivityLog(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading
    }
    // return useQuery({
    //     queryKey: ["GetActivityLog"],
    //     queryFn: () => getActivityLog(data),
    // });
}

export const useGetHomepageLeadData = () => {
    const mutation = useMutation({
        mutationFn: (data: GetHomeLeadsPayload) => getWeeklyOrMonthlySummary(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading
    };
}

export const useGetLeadsSummary = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => getLeadSummary(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading
    }
}
export const useGetLeadsPipeline = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => getLeadPipelines(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading,
        isError: mutation.isError
    }
}

export const useGetDistribution = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => getLeadDistribution(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading,
        isError: mutation.isError
    }
}

export const useGetMetricsFromAssignedChannel = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => getMetricsFromAssignedChannel(data),
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading,
        isError: mutation.isError
    }
}

export const useGetMetricsFromSourceChannel = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => {
            return getMetricsFromSourceChannel(data);
        }
    });
    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading,
        isError: mutation.isError
    }
}

export const useGetAccumulatedChartData = () => {
    const mutation = useMutation({
        mutationFn: (data: LeadsSummaryPayload) => {
            return getAccumulatedChartData(data);
        },
    });

    return {
        mutate: mutation.mutate,
        data: mutation.data,
        isLoading: mutation.isLoading,
        isError: mutation.isError
    }
}

export const useGetSocialInsights = (data: SearchReq) => {
    return useQuery({
        queryKey: ["SocialInsights", data.permission_Token],
        queryFn: () => getSocialInsightsData(data),
    });
}